export default __webpack_public_path__ + "static/media/impuritas-civitatis.765dd897.png";